import FolderCard from '../../../FolderCard';
import { getSubfoldersByParentId } from '../../selectors';
import { withMobileContext } from '../../../Context';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { setCurrentFolderId } from '../../actions';
var mapStateToProps = function (state, ownProps) { return ({
    subfolders: getSubfoldersByParentId(state, ownProps.folder.folderId),
    withCommentsCount: false,
    withLink: false,
    withShadow: !ownProps.isMobile,
}); };
var mapDispatchToProps = function (dispatch, ownProps) { return ({
    onClick: function () { return dispatch(setCurrentFolderId(ownProps.folder.folderId)); },
}); };
export default withMobileContext(connectMediaStore(mapStateToProps, mapDispatchToProps)(FolderCard));
//# sourceMappingURL=FolderCard.connected.js.map